import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import OrdersInProgressDoctors from "./OrdersInProgressDoctors";
import OrdersDoneDoctors from "./OrdersDoneDoctors";
import OrdersInClinicDoctors from "./OrdersInClinicDoctors";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { useSelector } from "react-redux";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const OrdersViewDoctors = () => {
  const theme = useTheme();
  const initIndex = useSelector((state) => state.routeReducer.index);
  const [value, setValue] = useState(initIndex);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [tabContent, setTabContent] = useState(1);
  useEffect(() => {
    console.log(tabContent);
  }, [tabContent]);
  return (
    <Grid container sx={{ maxWidth: "1400px" }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="در حال انجام" {...a11yProps(0)} />
          <Tab label="نزد پزشک" {...a11yProps(1)} />
          <Tab label="مختومه" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <Grid md={12}>
        <Paper sx={{ flexGrow: 1, p: 2 }}>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <OrdersInProgressDoctors />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <OrdersInClinicDoctors />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <OrdersDoneDoctors />
          </TabPanel>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default OrdersViewDoctors;
